import {fetch} from '../../utils/dataAccess';

export default async function createShipmentAddress(shipmentIri, values) {
    const body = {
        shipment: shipmentIri,
        firstname: values.firstname,
        lastname: values.lastname,
        company: values.company,
        address: values.address,
        addressMore: values.addressMore,
        postalCode: values.postalCode,
        city: values.city,
        country: values.country,
        phone: values.phone,
        email: values.email,
    };

    const response = await fetch(
        '/shipment_addresses',
        {
            method: 'POST',
            body: JSON.stringify(body),
            headers: new Headers({'Content-Type': 'application/ld+json'}),
        },
    );

    return await response.json();
}
